<template>
  <div class="organization-list-view">
    <div class="organization-list-view__header">
      <h3>{{ title }}</h3>
      <button v-if="userCanManageOrganizations" class="btn btn-success" @click.prevent="handleClickAddOrganization">
        <i class="fas fa-plus-circle" /> Nueva Organizacion
      </button>
    </div>
    <div class="organization-list-view__search">
      <app-search-input
        :title="`Buscar ${title}`"
        :placeholder="'Buscar por Rut, Nombre o Dirección'"
        @search="handleSearch" />
    </div>
    <organization-table
      ref="organizationTable"
      v-loading="fetchingOrganizations"
      :organizations="organizations"
      :pagination="pagination"
      :type="type"
      :title="title"
      :list-only="listOnly"
      :source="source"
      :active-search="currentSearch"
      @delete-organization="handleDeleteOrganization"
      @page-change="handlePageChange"
      @organization-saved="handleOrganizationSaved" />
  </div>
</template>

<script>
import AppSearchInput from '@/components/AppSearchInput';
import OrganizationTable from '@/components/user/OrganizationTable';
import _get from 'lodash/get';

export default {
  name: 'OrganizationListView',
  components: { AppSearchInput, OrganizationTable },

  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    source: {
      type: String,
      default: 'midas'
    },
    listOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      organizations: [],
      currentSearch: '',
      pagination: {
        total: 0,
        page: 1,
        perPage: 20
      },
      fetchingOrganizations: false
    };
  },
  computed: {
    userCanManageOrganizations() {
      return this.$store.getters.hasRole('admin') && !this.listOnly;
    }
  },
  watch: {
    type(newType, oldType) {
      if (newType !== oldType) {
        this.fetchOrganizations();
      }
    },
    source(newType, oldType) {
      if (newType !== oldType) {
        this.fetchOrganizations();
      }
    }
  },
  created() {
    this.fetchOrganizations();
  },
  methods: {
    handlePageChange(page) {
      this.fetchOrganizations({
        query: this.currentSearch,
        page
      });
    },
    fetchOrganizations(options = {}) {
      options = {
        query: this.currentSearch,
        type: this.type,
        ...this.pagination,
        ...options,
        source: this.source
      };
      this.fetchingOrganizations = true;
      this.organizations = [];
      this.$store.dispatch('fetchOrganizations', options)
        .then(response => {
          this.organizations = response.data;
          this.pagination = {
            total: parseInt(response.total),
            perPage: parseInt(response.perPage),
            page: parseInt(response.page)
          };
        })
        .finally(() => {
          this.fetchingOrganizations = false;
        });
    },
    handleDeleteOrganization(organization) {
      this.$confirm(`Está seguro que desea eliminar la organización: ${organization.name} - ${organization.rut}`, 'Confirmar eliminación de organización', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.deleteOrganization(organization);
      }).catch(() => {});
    },
    deleteOrganization(organization) {
      this.$store.dispatch('deleteOrganization', organization)
        .then(response => {
          this.$message({
            type: 'success',
            message: 'Organización eliminada'
          });
          this.fetchOrganizations();
        })
        .catch((e) => {
          this.$message({
            type: 'error',
            message: _get(e, 'response.data.message', 'Ha ocurrido un error al eliminar la organización')
          });
        });
    },
    handleClickAddOrganization() {
      this.$refs.organizationTable.handleClickAddOrganization();
    },
    handleSearch(search) {
      this.currentSearch = search;
      this.fetchOrganizations({
        query: search,
        page: 1
      });
    },
    handleOrganizationSaved() {
      this.fetchOrganizations();
    }
  }
};

</script>

<style lang="scss">
.organization-list-view {
  padding: $--spacing-6;

  &__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: $--spacing-6;
    margin-bottom: $--spacing-6;
    border-bottom: 1px solid $--color-light-gray;
  }
}
</style>
